import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Router } from '@angular/router';

@Component({
  selector: 'app-event-type',
  templateUrl: './event-type.component.html',
  styleUrls: ['./event-type.component.scss']
})
export class EventTypeComponent implements OnInit {

  public data: any[] = [
    {
      list: [{
        'type': 'in-person',
        'imageUrl': '/images/event-type/in-person.png',
        'name': 'In-Person Event',
        'description': 'In-Person event is for the events hosted completely in person. Supports table assignment, paddle assignment, and generation, and much more.',
        'selected': false
      }, {
        'type': 'virtual',
        'imageUrl': '/images/event-type/virtual.png',
        'name': 'Virtual Event',
        'description': 'Virtual Event is for the events entirely hosted virtually. Supports registration, RSVP, and other feature to manage and run virtual events.',
        'selected': false
      }]
    },
    {
      list: [{
        'type': 'hybrid',
        'imageUrl': '/images/event-type/hybrid.png',
        'name': 'Hybrid Event',
        'description': 'Hybrid Event supports both virtual and in-person being run simultaneously with participent participating from in room and virtualy at the same time.',
        'selected': false
      }]
    }
  ];
  
  public event = null;
  public confirmDisabled = true;

  constructor(
    public router: Router,
    public store: Store
  ) { }

  ngOnInit(): void {
  }

  onConfirm(event) {
    this.router.navigateByUrl(`event/${event.type}`);
  }

  onSelect(event) {
    if(this.event) {
      this.event.selected = false;
    }
    event.selected = true;
    this.event = event;

    this.confirmDisabled = false;
  }

}
